import * as React from 'react';
import { clsx } from 'clsx';
import { ApiError, apiPost, logApiError } from "../api";
import { useContext } from 'react';
import Spinner, { SpinnerColorsEnum } from "../components/spinner";
import FieldError from "../components/fieldError";
import { isFunction } from "../helpers/utils";
import { ContextSession } from "./app";
import { useForm, type SubmitHandler } from 'react-hook-form';
import { ErrorMessage } from "@hookform/error-message";
import HookFormDevToolLazy from "../../js/components/hookFormDevToolLazy";
import { inputClass } from "./utils";

type Props = Readonly<{
	setState: Function,
}>

type CodeFormValues = {
	code: string,
}

function FormCode({setState, ...otherProps}: Props) {

	const state = useContext(ContextSession);

	const {
		register,
		handleSubmit,
		formState: { errors, isSubmitting },
		control,
		setError,
	} = useForm<CodeFormValues>({
		defaultValues: {
			code: "",
		}
	});

	const onSubmit: SubmitHandler<CodeFormValues> = (data) => {
		data.transition = "validate";

		// /signature_requests/24113/transitions
		return apiPost('/resa/validateCode/' + state?.hash, data).then((response) => {
			if (isFunction(setState)) {
				setState(response.data);
			}
		}).catch(function(error) {
			if (error instanceof ApiError) {
				setError("code", { type: String(error.status) });
				setError("root.serverError", { type: String(error.status), message: error.data });
				logApiError(error);
			}
		});
	};

	return (<>
		<form onSubmit={handleSubmit(onSubmit)}>
			<HookFormDevToolLazy control={control}/>

			<div className="text-red-400 mb-4">
				<ErrorMessage errors={errors} name={'root.serverError'}/>
			</div>

			<div className="p-6 sm:p-8 bg-primary-200">
				<input
					type="number"
					className={clsx('mb-0 text-center', inputClass(errors.code))}
					placeholder="Enter code"
					autoComplete="off"
					{...register("code", { required: true, minLength: 6, maxLength: 6 })}
				/>
				<FieldError error={errors.code} message="Enter the 6-digit code"/>
			</div>
			<div className="p-6 sm:p-8 flex justify-center">
				<button disabled={isSubmitting} className="mb-0 flex items-center justify-center" type="submit">
					SUBMIT
					{isSubmitting && <Spinner color={SpinnerColorsEnum.Black} className="!w-4 !h-4"/>}
				</button>
			</div>
		</form>
	</>);
}

export default FormCode;
